import { PayloadAction } from "@reduxjs/toolkit";
import { AlertHelper } from "helpers";
import { EAlertType } from "helpers/alertHelper";
import {
  ICreateWarehouseRequest,
  ICreateWarehouseResponse,
  IDeleteByIdRequest,
  IDeleteWarehouseResponse,
  IUpdateWarehouseRequest,
  IUpdateWarehouseResponse,
} from "model";
import { IErrorResponse } from "model/Common/IErrorResponse";
import { call, put, takeEvery } from "redux-saga/effects";
import { WarehouseActions } from "redux/actions";
import { WarehouseApiService } from "services";

function* createWarehouse(action: PayloadAction<ICreateWarehouseRequest>) {
  try {
    const result: ICreateWarehouseResponse = yield call(
      WarehouseApiService.createWarehouse,
      action.payload
    );
    if (result.succeeded) {
      yield put(WarehouseActions.createWarehouse.success(result.data!));
      AlertHelper.showAlert("Create Successfully", EAlertType.SUCCESS);
    } else {
      const error = result as IErrorResponse;
      yield put(WarehouseActions.createWarehouse.failed(error));
    }
  } catch (error) {
    yield put(WarehouseActions.createWarehouse.failed(error));
  }
}

function* updateWarehouse(action: PayloadAction<IUpdateWarehouseRequest>) {
  try {
    const result: IUpdateWarehouseResponse = yield call(
      WarehouseApiService.updateWarehouse,
      action.payload
    );
    if (result.succeeded) {
      yield put(WarehouseActions.updateWarehouse.success(result.data!));
      AlertHelper.showAlert("Update Successfully", EAlertType.SUCCESS);
    } else {
      const error = result as IErrorResponse;
      yield put(WarehouseActions.updateWarehouse.failed(error));
    }
  } catch (error) {
    yield put(WarehouseActions.updateWarehouse.failed(error));
  }
}
function* deleteWarehouse(action: PayloadAction<IDeleteByIdRequest>) {
  try {
    const result: IDeleteWarehouseResponse = yield call(
      WarehouseApiService.deleteWarehouse,
      action.payload
    );
    if (result.succeeded) {
      yield put(WarehouseActions.deleteWarehouse.success(result.data!));
      AlertHelper.showAlert("Delete Successfully", EAlertType.SUCCESS);
    } else {
      const error = result as IErrorResponse;
      yield put(WarehouseActions.deleteWarehouse.failed(error));
    }
  } catch (error) {
    yield put(WarehouseActions.deleteWarehouse.failed(error));
  }
}

export function* Watcher() {
  yield takeEvery(WarehouseActions.createWarehouse.request, createWarehouse);
  yield takeEvery(WarehouseActions.updateWarehouse.request, updateWarehouse);
  yield takeEvery(WarehouseActions.deleteWarehouse.request, deleteWarehouse);
}
